var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail_wrapper"},[_c('top-banner'),_c('schema'),_c('fun'),_c('advantage'),_c('scene'),_c('value'),_c('demo'),_c('commend'),_c('more')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }